module.exports = __webpack_public_path__ + "img/icon-13.79e9838a.png";